<template>
  <f7-page :page-content="false">
    <!-- Top Navbar -->
    <f7-navbar title="Ayudas de las pantallas" :back-link="$t('atras')"></f7-navbar>
    <!-- Page content-->
    <f7-page-content class="full-height">
      <r-dynamic-list
        ref="rlist"
        :dbAdapter="Ayuda"
        :tableCode="'AYUDAS'"
        :tableMode="true"
        :virtualListParams="{height:32, rowsBefore:60, rowsAfter:60}"
        class="card full-height data-table"
        classContent="card-content full-height"
        :massiveActions="true"
        :controlsWidth="100"
      >
        <template v-slot:tableLinks>
          <a class="link" href="/ayudas/new/">Nueva ayuda</a>
        </template>
        <template v-slot:optionsColumn="{item}">
          <f7-link v-tooltip="$t('common.ver') + ' Ayuda'" icon-f7="eye" color="green" :href="`/ayudas/view/${item.id}/`"></f7-link>
          <f7-link icon-f7="square_pencil" color="blue" :href="`/ayudas/edit/${item.id}/`"></f7-link>
          <f7-link icon-f7="trash" color="red" @click="deleteItem(item.id)"></f7-link>
        </template>
      </r-dynamic-list>
    </f7-page-content>
  </f7-page>
</template>

<script>
import rDynamicList from "./../../components/rDynamicList.vue";
import Ayuda from "./../../js/db/Ayuda.js";

export default {
  components: {
    rDynamicList
  },
  data() {
    return {
      Ayuda
    };
  },
  methods: {
    deleteItem: function (id) {
      const self = this;
      var app = self.$f7;
      app.dialog.confirm(self.$t("rlist.pregunta_eliminar_registro"), "Eliminar", function () {
        Ayuda.delete({ itemId: id })
          .then(function (res) {
            if (res) {
              Ayuda.invalidarCache();
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: self.$t("rlist.registro_eliminado"),
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
              if (self.$refs.rlist) self.$refs.rlist.reload();
            }
          })
          .catch(function (error) {
            app.dialog.alert(error.message);
          });
      });
    }
  }
};
</script>
